function Square() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 300"><rect width="256" height="300" fill="none" /><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM168,96v64a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h64A8,8,0,0,1,168,96Z Square" />
      <text x="40" y="290" font-size="3em">Beta</text></svg>
  );
}

export default Square;
